import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildInstallablesGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getInstallable = buildInstallablesGetterObject('getInstallable');
export const getInstallables = buildInstallablesGetterObject('getInstallables');

const getters = {
	[getInstallables.getter]: (state) => Object.values(state.data),
	[getInstallable.getter]: (state) => (installableId) => state.data[installableId],
};

export default getters;
